export default __webpack_public_path__ + "static/media/Flag of Guatemala.51c88b05.gif";